export default __webpack_public_path__ + "ab971b407c6e5934665542245270e5d4.jpg";